import React, {useEffect, useRef, useState} from 'react';

const WavePlaceholder = ({
	barHeight = 1,
	barWidth = 6,
	barGap = 1,
	barColor = '#C7C7C7',
	opacity = 0.3,
}) => {
	const containerRef = useRef(null);
	const [barCount, setBarCount] = useState(0);

	useEffect(() => {
		const calculateBarCount = () => {
			if (!containerRef.current) {
				return;
			}

			const containerWidth = containerRef.current.clientWidth;
			const barFullWidth = barWidth + barGap;
			const count = Math.floor(containerWidth / barFullWidth);
			setBarCount(count);
		};

		calculateBarCount();
		window.addEventListener('resize', calculateBarCount);

		return () => {
			window.removeEventListener('resize', calculateBarCount);
		};
	}, [barWidth, barGap]);

	const bars = Array.from({length: barCount}, (_, i) => {
		const waveValue = Math.sin(i * 0.3) * 0.5 + 0.5;
		const heightPercent = 20 + waveValue * 60;

		return (
			<div
				key={i}
				style={{
					width: `${barWidth}px`,
					height: `${heightPercent}%`,
					backgroundColor: barColor,
					marginRight: `${barGap}px`,
					opacity,
					borderRadius: '2px',
				}}
			/>
		);
	});

	return (
		<div
			ref={containerRef}
			className="wave-placeholder"
			style={{
				display: 'flex',
				alignItems: 'center',
				height: '100%',
				width: '100%',
				position: 'relative',
			}}
		>
			{bars}
		</div>
	);
};

export default WavePlaceholder;
